import useTabs from './useTabs'
import useSegmentationFilter from './useSegmentationFilter'
import { useSegmentTypeOptions, useAllSegmentTypeOptions } from './useSegmentTypeOptions'

export default { useTabs, useAllSegmentTypeOptions, useSegmentTypeOptions, useSegmentationFilter }
